import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { RadiantSpinner } from 'components/RadiantSpinner'

import { PinnedNote } from 'modules/unsubscribe/components/PinnedNote'
import { useContinuedPlan } from 'modules/unsubscribe/pages/ContinuedPlan/useContinuedPlan'

import { AppName } from 'root-constants'

import { FemiButton } from '../../components/FemiButton'
import { FemiPageContainer } from '../../components/FemiPageContainer'
import { FemiBottomArea, FemiContent, FemiOutcomeTitle } from '../../styles'

export const FemiContinuedPlan: React.FC = () => {
  const { t } = useTranslation()
  const { isInProgress, goToAccountPage } = useContinuedPlan()

  return (
    <FemiPageContainer>
      {isInProgress ? (
        <FemiContent>
          <FemiOutcomeTitle>
            {t('retention.continuedPlan.step1Title')}
          </FemiOutcomeTitle>
          <RadiantSpinner />
        </FemiContent>
      ) : (
        <>
          <FemiContent>
            <FemiOutcomeTitle>
              {t('retention.continuedPlan.step2Title', {
                context: AppName.FEMI,
              })}
            </FemiOutcomeTitle>
            <PinnedNote>
              <Trans i18nKey="retention.femi.continuedPlan.note" />
            </PinnedNote>
          </FemiContent>
          <FemiBottomArea isFixed>
            <FemiButton type="button" onClick={goToAccountPage}>
              {t('retention.femi.continuedPlan.okButton')}
            </FemiButton>
          </FemiBottomArea>
        </>
      )}
    </FemiPageContainer>
  )
}
